/*global module:true*/

module.exports = {
  apiKey: "AIzaSyA8VXZwqhHx4qEtV5BcBNe41r7Ra0ZThfY",
  authDomain: "fir-b3915.firebaseapp.com",
  databaseURL: "https://fir-b3915.firebaseio.com",
  storageBucket: "",
};
